import { ChevronLeft, Delete, PhotoCamera } from '@mui/icons-material';
import { CircularProgress, IconButton, ImageList, ImageListItem, Tooltip, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { cloneDeep } from 'lodash';
import React, { useEffect, useState } from 'react';
import Api from '../../Api';
import { IImageDialogProps } from '../../interfaces/Common/IImageDialogProps';
import { IImage } from '../../interfaces/Common/IImage';



export const MaterialImageDialog: React.SFC<IImageDialogProps> = ({
    entityId,
    images,
    onImagesChanged,
    readonly,
    ...props
}: IImageDialogProps) => {

    useEffect(() => {
        setImageList(images);
    }, [images])

    const onChangeFile = async (e: React.ChangeEvent<HTMLInputElement>) => {

        if (e.target.files && entityId) {

            setUploading(true);

            let formData = new FormData();
            formData.append("materialId", entityId);

            let fileArr = Array.from(e.target.files);

            for (let i = 0; i < fileArr.length; i++) {
                formData.append(fileArr[i].name, fileArr[i]);
            }

            Api.Materials.uploadImage(entityId, formData).then((data: any) => {

                let imageData = data as IImage[];

                if (imageData) {
                    setImageList(imageData);
                    onImagesChanged(imageData);
                    setUploading(false);
                    e.target.value = "";
                }
            });
        }
    }

    const onDeleteImage = () => {
        if (selectedImage) {

            Api.Materials.removeImage(selectedImage.entityId, selectedImage.imageId).then(() => {

                let newImages = cloneDeep(imageList).filter(x => x.imageId !== selectedImage.imageId);
                setImageList(newImages);
                setSelectedImage(null);

                onImagesChanged(newImages);
            });

        }
    }

    const onClose = () => {
        setOpen(false);
        setSelectedImage(null);
    }

    const [open, setOpen] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [imageList, setImageList] = useState<IImage[]>([]);
    const [selectedImage, setSelectedImage] = useState<IImage | null>(null);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    return (
        <span>
            <Tooltip title="Upload Images">
                <IconButton onClick={() => setOpen(true)}>
                    {imageList !== null && imageList.length > 0 ?
                        <PhotoCamera color="primary" />
                        :
                        <PhotoCamera />
                    }
                </IconButton>
            </Tooltip>

            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                fullWidth
                maxWidth={selectedImage ? "lg" : "sm"}
            >

                {selectedImage ?

                    <>
                        <img
                            className="material-image-preview"
                            src={selectedImage.src}
                            srcSet={selectedImage.src}
                            alt={selectedImage.title}
                            loading="lazy"
                        />

                        <DialogActions sx={{ justifyContent: "space-between" }}>
                            <Button
                                startIcon={<ChevronLeft />}
                                onClick={() => setSelectedImage(null)}
                            >
                                Back
                            </Button>
                            <Typography textAlign="center" sx={{ mx: 1 }} variant="subtitle2">{selectedImage.title}</Typography>

                            {!readonly &&
                                <IconButton color="error" onClick={onDeleteImage}>
                                    <Delete />
                                </IconButton>
                            }

                        </DialogActions>
                    </>

                    :

                    <form
                        onSubmit={(e) => { }}
                        onInvalid={() => setErrorMessage("please check that all required fields have been populated")}
                    >
                        <DialogTitle>
                            Material Images
                        </DialogTitle>
                        <DialogContent>


                            {imageList !== null && imageList.length > 0 ?
                                <ImageList
                                    variant="quilted"
                                    cols={3}
                                >
                                    {imageList.map(image => (
                                        <Tooltip title={image.title} >
                                            <ImageListItem
                                                key={image.imageId}
                                                onClick={() => setSelectedImage(image)}
                                                sx={{ cursor: "pointer" }}
                                            >

                                                <img
                                                    src={image.src}
                                                    srcSet={image.src}
                                                    alt={image.title}
                                                    loading="lazy"
                                                />


                                            </ImageListItem>
                                        </Tooltip>
                                    ))}


                                    {uploading &&
                                        <ImageListItem sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            opacity: 0.5
                                        }}>
                                            <CircularProgress size={40} />
                                        </ImageListItem>
                                    }

                                </ImageList>

                                :

                                <Typography sx={{ mb: 2 }} color="GrayText">There are no images for this material.</Typography>


                            }

                            {!readonly &&
                                <Button
                                    variant={imageList !== null && imageList.length > 0 ? "outlined" : "contained"}
                                    component="label"
                                    disabled={uploading}
                                >
                                    Upload
                                    <input
                                        hidden
                                        accept="image/*"
                                        multiple
                                        onChange={onChangeFile}
                                        type="file"

                                    />
                                </Button>}

                            {errorMessage &&
                                <DialogContentText color="error">
                                    {errorMessage}
                                </DialogContentText>
                            }

                        </DialogContent>
                        <DialogActions>
                            <Button onClick={onClose}>Close</Button>
                        </DialogActions>
                    </form>

                }




            </Dialog>
        </span>
    );
}